export enum CommandeType {
  Mis_en_preparation = 'Mis en préparation',
  Envoye_en_mission = 'Envoyé en mission total',
  Envoyer_en_chargement = 'Envoyer en chargement',
  Edit = 'Edit',
  Create = 'Create',
  OTHER = 'OTHER',
}
